//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NsProductMixin from "../mixins/NsProductMixin.js";
import NsImage from "./NsImage.vue";

/**
 * NsProductLine
 *
 * How to use: Any variables used in the template that are not props in this
 * component come from the mixin.
 */

export default {
  name: "NsProductLine",
  components: {
    NsImage
  },
  // Note: The current usage of this component to require the product mixin
  // is overkil but plan to expand to use for the seach with pricing/add to cart
  mixins: [NsProductMixin],
  data() {
    return {
      referrer: "productLine"
    };
  }
};
